import React from 'react';
import './ReactTableStyles.scss'
import ReactBaseTable, {DefaultTableProps, FilterOptions} from "./ReactBaseTable";
import {Row} from "@tanstack/react-table";

type SyncTableProps<T extends object> = {
    isLoading: boolean;
    enableColumnResizing?: boolean;
    enableColumnGrouping?: boolean;
    initialSortColumn?: string;
    filterOptions: FilterOptions;
    defaultExpandedGroups?: boolean;
    rowColorCallback?: (row: Row<T>) => string;
} & DefaultTableProps<T>;

const ReactSyncTable = <T extends object>({
    tableId,
    data,
    columns,
    title,
    renderContainerHeaderItems,
    isLoading,
    filterOptions,
    enableColumnGrouping = true,
    enableColumnResizing = true,
    defaultExpandedGroups = true,
    rowColorCallback
}: SyncTableProps<T>) => {

    return (<ReactBaseTable
        tableId={tableId}
        title={title}
        renderContainerHeaderItems={renderContainerHeaderItems}
        data={data}
        columns={columns}
        isAsync={false}
        filterOptions={filterOptions}
        isLoading={isLoading}
        enableColumnGrouping={enableColumnGrouping}
        enableColumnResizing={enableColumnResizing}
        defaultExpandedGroups={defaultExpandedGroups}
        rowColorCallback={rowColorCallback}
    />);
};

export default ReactSyncTable;
